import React, { useMemo } from 'react';
import { notification } from 'antd';
import { BaseComponentProps } from '../types';
import { NotificationInstance } from 'antd/es/notification/interface';

export type NotificationContextType = {
  notificationApi: NotificationInstance;
};

export const NotificationContext = React.createContext<NotificationContextType>(null);

export default function NotificationProvider({ children }: BaseComponentProps) {
  const [notificationApi, notificationContextHolder] = notification.useNotification({
    duration: 0,
  });

  const context = useMemo(
    () => ({
      notificationApi,
    }),
    [notificationApi],
  );

  return (
    <NotificationContext.Provider value={context}>
      {notificationContextHolder}
      {children}
    </NotificationContext.Provider>
  );
}
